module.exports = __webpack_public_path__ + "static/media/close_nav.19452920.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_nav.svg
// module id = 850
// module chunks = 3